"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const analytics_1 = require("@completeanatomy/analytics");
const bridge_1 = require("@completeanatomy/bridge");
const bridge_schema_1 = require("@completeanatomy/bridge-schema");
const StructureClusterNames_1 = require("../../atoms/StructureClusterNames");
const hooks_1 = require("../../hooks");
const InfoboxMenu_1 = require("../../molecules/InfoboxMenu");
const PanelMenu_1 = __importDefault(require("../../molecules/PanelMenu"));
const react_1 = require("react");
const react_transition_group_1 = require("react-transition-group");
const styled_components_1 = __importDefault(require("styled-components"));
const ButtonActionToolbar_1 = __importDefault(require("../ButtonActionToolbar"));
const InfoboxDescriptionPanel_1 = __importDefault(require("../InfoboxDescriptionPanel"));
const SlideOutPanel_1 = __importDefault(require("../SlideOutPanel"));
const ViewControls_1 = __importDefault(require("../ViewControls"));
const ANIMATION_TIME = 700;
function MobileInfoboxPanel({ audio, currentTab, information, isDescriptionPanelOpen, isSidePanelOpen, isSpotPanelOpen, items, names, setIsSidePanelOpen, onItemClick, setCurrentTab, setIsOverlayOpened, }) {
    const buttonRef = (0, react_1.useRef)(null);
    const bridge = (0, bridge_1.useBridge)();
    (0, hooks_1.useSelectInfoBoxTab)(currentTab);
    const analytics = (0, analytics_1.useAnalytics)();
    const onClose = (0, react_1.useCallback)(() => {
        bridge === null || bridge === void 0 ? void 0 : bridge.infoBoxCloseAction();
        setIsSidePanelOpen(false);
    }, [setIsSidePanelOpen, bridge]);
    const onClickMinimise = () => {
        analytics.log('collapse_infobox_pressed', {
            name: 'infobox' + (currentTab ? '_minimized' : '_maximized'),
            accessLocation: analytics_1.AnalyticsAccessLocation.Infobox,
        });
        if (currentTab) {
            setCurrentTab(bridge_schema_1.InfoBoxTabType.None);
            setIsSidePanelOpen(false);
        }
        else {
            setIsSidePanelOpen(true);
            setCurrentTab(bridge_schema_1.InfoBoxTabType.Description);
        }
    };
    return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)(react_transition_group_1.CSSTransition, { in: isSidePanelOpen, timeout: ANIMATION_TIME, appear: true, classNames: "slide", unmountOnExit: false, "data-e2e": 'MobileInfoboxPanel_CSSTransition', children: (0, jsx_runtime_1.jsxs)(Container, { ref: buttonRef, "data-e2e": 'MobileInfoboxPanel_Container', children: [!currentTab && ((0, jsx_runtime_1.jsx)(ViewControlsStylesContainer, { "data-e2e": 'MobileInfoboxPanel_ViewControlsStylesContainer', children: (0, jsx_runtime_1.jsx)(ViewControls_1.default, { "data-e2e": 'MobileInfoboxPanel_ViewControls' }) })), (0, jsx_runtime_1.jsxs)(Infobox, { "data-e2e": 'MobileInfoboxPanel_Infobox', children: [(0, jsx_runtime_1.jsxs)(NameAndButtonContainer, { "data-e2e": 'MobileInfoboxPanel_NameAndButtonContainer', children: [(0, jsx_runtime_1.jsx)(StructureClusterNames_1.StructureClusterNames, { firstName: (names === null || names === void 0 ? void 0 : names.english) || '', secondaryName: (names === null || names === void 0 ? void 0 : names.latin) || '', isCentered: false, "data-e2e": 'MobileInfoboxPanel_StructureClusterNames' }), (0, jsx_runtime_1.jsx)(ButtonActionToolbar_1.default, { onClose: onClose, audioFile: audio, alternativeNames: names === null || names === void 0 ? void 0 : names.alternative, name: names === null || names === void 0 ? void 0 : names.title, onClickMinimise: onClickMinimise, isSelectedMinimise: currentTab === 0, "data-e2e": 'MobileInfoboxPanel_ButtonActionToolbar' })] }), (0, jsx_runtime_1.jsx)(InfoboxMenuContainer, { "data-e2e": 'MobileInfoboxPanel_InfoboxMenuContainer', children: (0, jsx_runtime_1.jsx)(InfoboxMenu_1.InfoboxMenu, { onItemClick: onItemClick, currentTab: currentTab, "data-e2e": 'MobileInfoboxPanel_InfoboxMenu' }) })] })] }) }), (0, jsx_runtime_1.jsxs)(SlideOutPanel_1.default, { currentTab: currentTab, isOpen: isSidePanelOpen, setCurrentTab: setCurrentTab, "data-e2e": 'MobileInfoboxPanel_SlideOutPanel', children: [(0, jsx_runtime_1.jsx)(InfoboxDescriptionPanel_1.default, { isOpen: isDescriptionPanelOpen, onClose: onClose, descriptionText: information || '', "data-e2e": 'MobileInfoboxPanel_InfoboxDescriptionPanel' }), (0, jsx_runtime_1.jsx)(PanelMenu_1.default, { activeTab: currentTab, onClose: onClose, isOpen: isSpotPanelOpen, setIsOverlayOpened: setIsOverlayOpened, items: items, "data-e2e": 'MobileInfoboxPanel_PanelMenu' })] })] }));
}
exports.default = MobileInfoboxPanel;
const Container = styled_components_1.default.div `
  position: absolute;
  display: flex;
  width: 100%;
  bottom: 0;
  left: 0;
  border-radius: 0px;
  box-sizing: border-box;
  flex-direction: column;

  &.slide-appear,
  &.slide-enter {
    bottom: 0;
  }

  &.slide-appear-active,
  &.slide-enter-active {
    transform: translateY(-40vh);
    transition: transform ${ANIMATION_TIME}ms ease-in-out;
  }
  &.slide-enter-done {
    transform: translateY(-40vh);
    transition: transform ${ANIMATION_TIME}ms ease-in-out;
  }
  &.slide-exit {
    transform: translateY(-40vh);
    transition: transform ${ANIMATION_TIME}ms ease-in-out;
  }
  &.slide-exit-active {
    transform: translateY(0);
  }
  &.slide-exit-done {
    transform: translateY(0);
  }
`;
const InfoboxMenuContainer = styled_components_1.default.div `
  width: 100%;
  max-width: 100vw;
  height: 100%;
`;
const ViewControlsStylesContainer = styled_components_1.default.div `
  z-index: 2;
  margin-bottom: 10px;
  margin-left: 8px;
  width: fit-content;
  background: ${props => props.theme.grasshopper.infoBox.slideOutPanelMobileBackground};
`;
const NameAndButtonContainer = styled_components_1.default.div `
  display: flex;
`;
const Infobox = styled_components_1.default.div `
  padding: 16px 8px;
  background: ${props => props.theme.grasshopper.infoBox.slideOutPanelMobileBackground};
`;
